module.exports = __webpack_public_path__ + "img/premio-box-icon-soci_569x569.a92a80d3.png";